export const HIDE_SIDE_DRAWER = "HIDE_SIDE_DRAWER";
export const hideSideDrawer = () => ({ type: HIDE_SIDE_DRAWER });

export const SHOW_SIDE_DRAWER = "SHOW_SIDE_DRAWER";
export const showSideDrawer = () => ({ type: SHOW_SIDE_DRAWER });

export const TOGGLE_SIDE_DRAWER = "TOGGLE_SIDE_DRAWER";
export const toggleSideDrawer = () => ({ type: TOGGLE_SIDE_DRAWER });
